import { TranslationsService } from '@inter-ikea-kompis/services';
import { getLocale } from '../utils/i18nUtils';
import { getRange } from '../utils/queryUtils';
import { getDexfSettings } from './dexfSettingsService';
import { isKiosk } from '../utils/platform';
import { isFeatureEnabled } from '../utils/featureEnabled';
import { Feature } from '../enums/Feature';
import { getTranslationEndpoints } from './translationEndpoints';
/**
 * Phrase uses double curly brackets {{parameter}} but our formatMessage can only handle single {parameter}.
 * This function converts those keys with two curly brackets to one instead
 */
const replaceDoubleCurlyBrackets = (obj) => {
    if (typeof obj === 'string') {
        return obj.replace(/{{/g, '{').replace(/}}/g, '}');
    }
    else if (Array.isArray(obj)) {
        return obj.map(item => replaceDoubleCurlyBrackets(item));
    }
    else if (typeof obj === 'object' && obj !== null) {
        return Object.keys(obj).reduce((acc, key) => {
            acc[key] = replaceDoubleCurlyBrackets(obj[key]);
            return acc;
        }, {});
    }
    return obj;
};
// TODO: Implement caching as a contribution in Kompis instead
const translationCache = new Map();
export const clearPhraseTranslationsCache = () => {
    translationCache.clear();
};
export const getPhraseTranslations = async (locale) => {
    const localeToUse = locale || getLocale();
    if (!translationCache.has(localeToUse)) {
        translationCache.set(localeToUse, {
            callbacks: null,
            translations: null
        });
    }
    const cache = translationCache.get(localeToUse);
    if (cache.translations) {
        return cache.translations;
    }
    else if (cache.callbacks) {
        return await new Promise(resolve => {
            cache.callbacks?.push(resolve);
        });
    }
    cache.callbacks = [];
    const range = getRange();
    const applicationName = range.toUpperCase();
    const service = new TranslationsService({
        translationEndpoints: getTranslationEndpoints(getLocale()),
        locale: locale || getLocale(),
        translationPrefixApplication: applicationName
    });
    const translations = (await service.getTranslations());
    const settings = await getDexfSettings();
    // TODO: Temporary fix until we have save design to profile in place
    if (isKiosk() || !isFeatureEnabled(settings, Feature.saveToProfile)) {
        translations.kompis.share = translations.storageone.saveForLater;
        translations.kompis.shareDesignCardDefaultTitle = translations.storageone.saveForLater;
    }
    cache.translations = translations;
    for (const callback of cache.callbacks) {
        callback(translations);
    }
    cache.callbacks = null;
    return Object.assign(translations, {
        storageone: replaceDoubleCurlyBrackets(translations.storageone)
    });
};
//# sourceMappingURL=phraseTranslationService.js.map